import { render, staticRenderFns } from "./BoltAppSwitcher.vue?vue&type=template&id=a514692e"
import script from "./BoltAppSwitcher.vue?vue&type=script&lang=js"
export * from "./BoltAppSwitcher.vue?vue&type=script&lang=js"
import style0 from "./BoltAppSwitcher.vue?vue&type=style&index=0&id=a514692e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports